export default {
  index: [
    {
      path: '/footcommity',
      component: resolve => require(['./footcommodityIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/footcommodity/_router.js